module.exports = __webpack_public_path__ + "img/制御工学5_6_1.7cab8468.png";